import React from "react";
import * as Sentry from "@sentry/react";
import Layout from "../layouts/index";
import SingleTrip from "../screens/Booking/SingleTrip";
import ToasterProvider from "../components/Toaster";
import SingleBookingDetails from "./SingleBookingDetails";

const SingleTripPage = () => {
  return (
    <Layout>
      <ToasterProvider>
      {/* <SingleTrip /> */}
      <SingleBookingDetails/>
      </ToasterProvider>
    </Layout>
  );
};

export default SingleTripPage;
